import Component from '@bythepixel/component-loader';

export default class DealerList extends Component {
  static selector = '[comp-dealer-locator-list]';
  static DEFAULTS = { map: undefined };

  #map;
  #cards = [];
  #markers = {};
  #activeCard = null;

  constructor(el, options, loaderInstance) {
    super(el, options, loaderInstance);
    this.$setOptions(options, DealerList.DEFAULTS);
    this.#map = this.$options.map;
    this.events();
  }

  events() {
    document.addEventListener('dealer-locator:data-loaded', (e) => this.render(e.detail.dealers));
    document.addEventListener('dealer-locator:modal-opened', () => this.resizeMap());
    document.addEventListener('dealer-locator:sort-by-location', (e) => {
      this.sortByDistance(e.detail.lat, e.detail.lng);
    });
    document.addEventListener('dealer-locator:sort-reset', () => this.resetSort());
  }

  render(dealers) {
    this.$container.innerHTML = '';
    this.#cards = [];
    this.#markers = {};

    dealers.forEach((dealer) => {
      const card = createCard(dealer);
      this.$container.appendChild(card);
      this.#cards.push({ el: card, dealer });

      const marker = this.#map.addMarker(dealer);
      this.#markers[dealer.id] = marker;

      marker.on('click', () => this.highlightCard(dealer));
      card.addEventListener('click', () => this.selectDealer(dealer, card));
    });

    this.#map.fitBounds();
  }

  selectDealer(dealer, card) {
    this.setActive(card);
    this.#map.flyTo({ center: [dealer.longitude, dealer.latitude], zoom: 10 });

    this.$publish('dealer-locator:select', { dealer });
    document.dispatchEvent(new CustomEvent('dealer-locator:select', { detail: { dealer } }));
  }

  highlightCard(dealer) {
    const entry = this.#cards.find((c) => c.dealer.id === dealer.id);
    if (entry) {
      this.setActive(entry.el);
      entry.el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      this.#map.flyTo({ center: [dealer.longitude, dealer.latitude], zoom: 10 });

      document.dispatchEvent(new CustomEvent('dealer-locator:preview', { detail: { dealer } }));
    }
  }

  setActive(cardEl) {
    if (this.#activeCard) {
      this.#activeCard.classList.remove('dealer-locator__card--active');
    }
    cardEl.classList.add('dealer-locator__card--active');
    this.#activeCard = cardEl;
  }

  sortByDistance(lat, lng) {
    this.#cards.forEach(({ dealer }) => {
      const dist = haversine(lat, lng, dealer.latitude, dealer.longitude);
      this.#markers[dealer.id].sortDistance = dist;
    });

    this.#cards.sort((a, b) => {
      const distA = this.#markers[a.dealer.id].sortDistance;
      const distB = this.#markers[b.dealer.id].sortDistance;
      return distA - distB;
    });

    this.#cards.forEach(({ el }) => this.$container.appendChild(el));
    this.$container.scrollTop = 0;
    this.#map.fitBoundsToVisible();
  }

  resetSort() {
    this.#cards.sort((a, b) => a.dealer.title.localeCompare(b.dealer.title));
    this.#cards.forEach(({ el }) => this.$container.appendChild(el));
    this.$container.scrollTop = 0;
    this.#map.fitBounds();
  }

  resizeMap() {
    setTimeout(() => {
      this.#map.get().resize();
      this.#map.fitBounds();
    }, 100);
  }
}

function createCard(dealer) {
  const card = document.createElement('div');
  card.className = 'dealer-locator__card';
  card.dataset.id = dealer.id;
  card.innerHTML = `
    <span class="dealer-locator__card-name">${escapeHtml(dealer.title)}</span>
    <span class="dealer-locator__card-address">${escapeHtml(dealer.address)}</span>
    <span class="dealer-locator__card-address">${escapeHtml(dealer.city)}, ${escapeHtml(dealer.state)} ${escapeHtml(dealer.zip)}</span>
  `;
  return card;
}

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

function haversine(lat1, lng1, lat2, lng2) {
  const R = 3959;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const sinDLat = Math.sin(dLat / 2);
  const sinDLng = Math.sin(dLng / 2);
  const a = (sinDLat * sinDLat)
    + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * (sinDLng * sinDLng);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function toRad(deg) {
  return (deg * Math.PI) / 180;
}
